/**
 * Feature Flags Configuration
 *
 * Feature flags controlled via environment variables.
 * Set these in your .env file or deployment environment.
 */

// Feature flags from environment variables
export const featureFlags = {
  /**
   * Material Type Restriction
   * When enabled, stations can be restricted to specific material types
   * (Chicken, Beef, Pork, Goat/Lamb) and sessions can only be assigned
   * to stations with matching material types.
   */
  MATERIAL_TYPE_RESTRICTION: import.meta.env.VITE_FEATURE_MATERIAL_TYPE_RESTRICTION === 'true',

  /**
   * Scanner Integration
   * When enabled, shows barcode scanner features for scan verification.
   */
  SCANNER_INTEGRATION: import.meta.env.VITE_FEATURE_SCANNER_INTEGRATION === 'true',

  /**
   * Camera Integration
   * When enabled, shows camera management and monitoring features.
   */
  CAMERA_INTEGRATION: import.meta.env.VITE_FEATURE_CAMERA_INTEGRATION === 'true',

  /**
   * Production Transfer
   * When enabled, shows the production transfer feature for moving sessions between stations.
   */
  PRODUCTION_TRANSFER: import.meta.env.VITE_FEATURE_PRODUCTION_TRANSFER === 'true',

  /**
   * Item Catalog
   * When enabled, shows the Item Catalog submenu under Inventory.
   * When disabled, Inventory becomes a single tab linking directly to the dashboard.
   */
  ITEM_CATALOG: import.meta.env.VITE_FEATURE_ITEM_CATALOG === 'true',
};

export type FeatureFlagKey = keyof typeof featureFlags;
export const featureFlagKeys = Object.keys(featureFlags) as FeatureFlagKey[];

// Get a specific flag value
export const getFeatureFlag = (key: FeatureFlagKey): boolean => {
  return featureFlags[key];
};

export default featureFlags;
